/**
 * ADR-0024 D9.3 - padrao unico de erro.
 *
 * O backend ja possui tratamento de excecoes centralizado e rico
 * (`apps/api/exception_handlers.py`). Esta camada traduz aquele formato em um
 * objeto unico, sempre carregando o `X-Request-ID` da resposta para que
 * qualquer relato de usuario seja rastreavel ate o trace no Application
 * Insights com um clique.
 */
export class ApiError extends Error {
  readonly status: number
  readonly requestId: string | null
  readonly detail: unknown

  constructor(message: string, status: number, requestId: string | null, detail: unknown) {
    super(message)
    this.name = 'ApiError'
    this.status = status
    this.requestId = requestId
    this.detail = detail
  }

  get isNetworkError(): boolean {
    return this.status === 0
  }

  get isUnauthorized(): boolean {
    return this.status === 401
  }

  get isForbidden(): boolean {
    return this.status === 403
  }
}
